// extracted by mini-css-extract-plugin
module.exports = {"EnvBanner":"styles_EnvBanner__2jCzN","EnvBannerDev":"styles_EnvBannerDev__1Y7Jl","EnvBannerTest":"styles_EnvBannerTest__3L-wI"};